import { BehaviorSubject, firstValueFrom, lastValueFrom, Subject } from "rxjs";
import { ApiService } from "../../../02_utils/apiService";
import { Logger } from "../../../02_utils/logger";
import { Utils } from "../../../02_utils/utils";
import { IFilters, ISearchModel, ISearchRequest, SearchRequest } from "../dto/requestBody.dto";
import { Field, FilterResponse, IField, IFilterResponse } from "../../filter/dto/filter.dto";
import { LoaderService } from "../../filter/Services/loaderService";
import { RequestService } from "../../filter/Services/requestService";


export class SearchRequestService {
  private search: HTMLElement;
  private dummyCard: HTMLElement;
  private loadingFailed: HTMLElement;
  private filters: Array<IFilters>;

  public requestBody: ISearchRequest = new SearchRequest;
  public dataModel: Subject<ISearchModel> = new Subject();
  public currentFilters: {[key: string]: string} = {};


  constructor(
    search: HTMLElement,
    filters: Array<IFilters>,
    private $log: Logger,
    private $utils: Utils,
    private $apiService: ApiService,
  ) {
    this.search = search;
    this.filters = filters;
    this.dummyCard = search.querySelector('[data-dummy]');
    this.loadingFailed = search.querySelector('[data-loading-failed]');
  }

  public async loadNextPage(): Promise<void> {

    this.$utils.addOrRemoveClases('add', 'd-none', this.loadingFailed);

    this.filters.forEach(filter => {
      filter.loaderService.activateLoader();
      filter.loaderService.activateSkeletonLoader();
    });

    await this.$apiService.postFilter<ISearchModel>('/websitesearch/products', this.requestBody, false)
    .then((response) => {
      if (response) {
        this.dataModel.next(response.data);
      } else {
        throw Error();
      }
    })
    .catch(() => {
      this.$utils.addOrRemoveClases('remove', 'd-none', this.loadingFailed);
    });

    this.filters.forEach(filter => {
      filter.loaderService.deactivateLoader();
      filter.loaderService.deactivateSkeletonLoader();
    });
  }
}
